const URL_PATTERN = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;
const SIMPLE_TRAILING_PUNCTUATION = /[.,!?;:]$/;
const CLOSING_PAIRS = {
  ")": "(",
  "]": "[",
  "}": "{",
};

const countCharacter = (value, character) =>
  [...value].filter((currentCharacter) => currentCharacter === character).length;

const splitTrailingPunctuation = (candidate) => {
  let url = candidate;
  let trailingText = "";

  while (url) {
    const lastCharacter = url.at(-1);
    const openingCharacter = CLOSING_PAIRS[lastCharacter];
    const hasUnmatchedClosingCharacter = openingCharacter
      && countCharacter(url, lastCharacter) > countCharacter(url, openingCharacter);

    if (!SIMPLE_TRAILING_PUNCTUATION.test(lastCharacter) && !hasUnmatchedClosingCharacter) {
      break;
    }

    trailingText = lastCharacter + trailingText;
    url = url.slice(0, -1);
  }

  return { url, trailingText };
};

export const linkifyChatMessage = (message = "") => {
  const text = String(message);
  const parts = [];
  let lastIndex = 0;

  for (const match of text.matchAll(URL_PATTERN)) {
    const matchIndex = match.index ?? 0;
    const { url, trailingText } = splitTrailingPunctuation(match[0]);

    if (matchIndex > lastIndex) {
      parts.push({ type: "text", text: text.slice(lastIndex, matchIndex) });
    }

    parts.push({
      type: "link",
      text: url,
      href: url.toLowerCase().startsWith("www.") ? `https://${url}` : url,
    });

    if (trailingText) {
      parts.push({ type: "text", text: trailingText });
    }

    lastIndex = matchIndex + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push({ type: "text", text: text.slice(lastIndex) });
  }

  return parts.length ? parts : [{ type: "text", text }];
};
